<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <Header />

    <div
      class="bCardGlobalXL mt-4 pt-2 pb-5"
      style="
        background-color: white !important;
        padding-top: 0px;
        padding-bottom: 0px;
        min-height: 90vh;
      "
    >
      <div class="divSubtitulo d-flex justify-content-between">
        <p class="textoSubtitulo">Tratamientos sesión</p>
        <p style="text-align: end" class="textoSubtitulo"></p>
      </div>

      <b-row class="ml-1">
        <b-col cols="2" class="d-flex flex-column p-0" style="margin-top: 2.8%;">
          <div class="d-flex flex-column align-items-center pl-2 pr-2" style="border: 1px solid #90D3DD; border-radius: 15px;">
            <div class="p-1 pl-3 pr-3 mt-2" style="background-color: #247baf; color: white; border-radius: 20px; font-weight: 600;">
              <p class="m-0" style="font-weight: 500;">Paciente</p>
            </div>
            <em class="paciente mt-3" style="width: 6em"></em>
            <p class="mt-2 truncate" ref="pacienteText" style="font-weight: 500;" v-b-tooltip.hover :title="isPacienteTruncated ? nombrePaciente : ''">
              {{ nombrePaciente }}
            </p>
            <p class="mt-1">{{ idPaciente }}</p>
          </div>

          <div class="d-flex flex-column align-items-center pl-2 pr-2 mt-3" style="border: 1px solid #90D3DD; border-radius: 15px;">
            <div class="p-1 pl-3 pr-3 mt-2" style="color: #6DA6C8; border-radius: 20px; font-weight: 600;">
              <p class="m-0" style="font-weight: 500;">Doctor</p>
            </div>
            <em class="doctor mt-3" style="width: 6em"></em>
            <p class="mt-2 truncate" ref="doctorText" style="font-weight: 500;" v-b-tooltip.hover :title="isDoctorTruncated ? nombreEmpleado : ''">
              {{ nombreEmpleado }} 
            </p>
            <p class="mt-1">{{ nombreEspecialidades }}</p>
          </div>
        </b-col>

        <b-col style="margin-top: 1%;">
          <tratamiento-sesion-nuevo
            class="p-0 m-0 d-flex justify-content-end mb-3"
            v-on:nombre="setNombreEmpleado"
            v-on:especialidad="setEspecialidadesNombre"
          ></tratamiento-sesion-nuevo>
         <CardTratamientosSesion/>
        </b-col>
      </b-row>

    </div>
  </div>
</template>
<script>
import Header from "@/components/Header";
import CardTratamientosSesion from "@/views/TratamientosSesion/CardTratamientosSesion";
import TratamientoSesionNuevo from "@/views/TratamientosSesion/tratamientoSesionNuevo";

export default {
  name: "tratamientoSesion",

  components: {
    CardTratamientosSesion,
    TratamientoSesionNuevo,
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    nombrePaciente: null,
    nombreEmpleado: "",
    nombreEspecialidades: "",
    idPaciente: null,
    isPacienteTruncated: false,
    isDoctorTruncated: false
  }),
  mounted() {
    this.nombrePaciente = this.$route.params.nombre;
    this.$nextTick(this.checkTruncation);
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idPaciente = this.$route.params.idPaciente;
  },
  methods: {
    setNombreEmpleado(nombre) {
      this.nombreEmpleado = nombre;
    },
    setEspecialidadesNombre(especialidadesNombre) {
      this.nombreEspecialidades = especialidadesNombre;
    },
    checkTruncation() {
      this.isPacienteTruncated = this.isTextTruncated(this.$refs.pacienteText);
      this.isDoctorTruncated = this.isTextTruncated(this.$refs.doctorText);
    },
    isTextTruncated(el) {
      return el && (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth);
    }
  },
};
</script>

<style scoped>
.truncate {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

</style>
